export default __webpack_public_path__ + "./fonts/doc.42ccb3a3.svg";